import React, { useState, useEffect } from 'react';

export const Hero = () => {
  const [logoVisible, setLogoVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLogoVisible(true);
    }, 400);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="hero-section">
      <div 
        className="hero-background-gif"
        style={{ 
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_refined-spaces-2/artifacts/6761o7uz_file%202.gif)'
        }}
      />
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className={`logo-simple-fade ${logoVisible ? 'logo-fade-in' : ''}`}>
          <img 
            src="https://customer-assets.emergentagent.com/job_refined-spaces-2/artifacts/w4pt09s7_1NEW%20Domus%20Living%20Logo%20Inverted-Recovered.png" 
            alt="Domus Living Logo" 
            className="hero-logo-image"
          />
        </div>
      </div>
    </div>
  );
};
